import React from 'react'
import classNames from 'classnames'

import './Button.scss'
import { CssLayoutProperties } from '../utils/CssLayoutProperties'

export type ButtonStyle = 'grey' | 'green' | 'redStroke' | 'greenOnGrey' | 'whiteStroke' | 'link' | 'inlineLink' | 'blackLink'
| 'white' | 'debug' | 'greenSegmentedLeft' | 'greenSegmentedRight' | 'default' // default does nothing; white with green stroke

export interface ButtonProps {
  buttonStyle?: ButtonStyle
  children: React.ReactNode
  onClick?: (() => void) | null
  disabled?: boolean
  round?: boolean
  mobileRound?: boolean
  flat?: boolean
  style?: CssLayoutProperties
  isActive?: boolean
}

const Button: React.FC<ButtonProps> = (
  {
    children,
    onClick,
    disabled,
    buttonStyle,
    round,
    mobileRound,
    flat,
    style,
    isActive
  }) => {
  return (
    <button
      disabled={disabled}
      className={classNames('button', buttonStyle, { disabled, round, flat, mobileRound, isActive })}
      onClick={(!disabled && onClick) ? onClick : undefined}
      style={style}
    >
      {children}
    </button>
  )
}

export default Button
